// extracted by mini-css-extract-plugin
export default {"anchorContainer":"cca2V6rf4","icon":"cxU6Xt0zo"};